import { Url } from "../api_settings/api_constants";
import { wrappedFetch, wrappedGet } from "../api_settings/urlFunctions";


// get license object data
export const getFilterStates = () => {
    return wrappedGet(Url.GET_STATES, "GET");
};

// get license object data
export const getCategoryProduct = (id) => {
    return wrappedGet(Url.GET_CATEGORY_PRODUCT + id, "GET");
};

// get license object data
export const getSpeciesArea = (id) => {
    return wrappedGet(Url.GET_SPECIES_AREA + id, "GET");
};

// get license object data
export const getClassArea = (id) => {
    return wrappedGet(Url.GET_CLASS_AREA + id, "GET");
};

// get search filters
export const getSearchFilters = (data) => {
    return wrappedFetch(Url.FILTER_BY_TYPES, "POST", data);
}




